module.exports = {"350628100":"小溪镇","350628101":"山格镇","350628102":"文峰镇","350628103":"南胜镇","350628104":"坂仔镇","350628105":"安厚镇","350628106":"大溪镇","350628107":"霞寨镇","350628108":"九峰镇","350628109":"芦溪镇","350628200":"五寨乡","350628201":"国强乡","350628202":"崎岭乡","350628203":"长乐乡","350628204":"秀峰乡","350628400":"安厚农场","350628401":"福建平和工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350628.json
// module id = 1217
// module chunks = 0